import React from "react";
import LeaveSheets from "../../components/StaffTabs/LeaveSheet/LeaveSheets";

const LeaveSheet = () => {
  return (
    <div>
      
      <LeaveSheets/>
    </div>
  );
};

export default LeaveSheet;
